// @generated by protoc-gen-connect-es v1.4.0
// @generated from file penumbra/custody/v1/custody.proto (package penumbra.custody.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { AuthorizeRequest, AuthorizeResponse, AuthorizeValidatorDefinitionRequest, AuthorizeValidatorDefinitionResponse, AuthorizeValidatorVoteRequest, AuthorizeValidatorVoteResponse, ConfirmAddressRequest, ConfirmAddressResponse, ExportFullViewingKeyRequest, ExportFullViewingKeyResponse } from "@buf/penumbra-zone_penumbra.bufbuild_es/penumbra/custody/v1/custody_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * The custody protocol is used by a wallet client to request authorization for
 * a transaction they've constructed.
 *
 * Modeling transaction authorization as an asynchronous RPC call encourages
 * software to be written in a way that has a compatible data flow with a "soft
 * HSM", threshold signing, a hardware wallet, etc.
 *
 * The custody protocol does not trust the client to authorize spends, so
 * custody requests must contain sufficient information for the custodian to
 * understand the transaction and determine whether or not it should be
 * authorized.
 *
 * @generated from service penumbra.custody.v1.CustodyService
 */
export const CustodyService = {
  typeName: "penumbra.custody.v1.CustodyService",
  methods: {
    /**
     * Requests authorization of the transaction with the given description.
     *
     * @generated from rpc penumbra.custody.v1.CustodyService.Authorize
     */
    authorize: {
      name: "Authorize",
      I: AuthorizeRequest,
      O: AuthorizeResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Requests authorization of the given validator definition update.
     *
     * @generated from rpc penumbra.custody.v1.CustodyService.AuthorizeValidatorDefinition
     */
    authorizeValidatorDefinition: {
      name: "AuthorizeValidatorDefinition",
      I: AuthorizeValidatorDefinitionRequest,
      O: AuthorizeValidatorDefinitionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Requests authorization of the given validator vote.
     *
     * @generated from rpc penumbra.custody.v1.CustodyService.AuthorizeValidatorVote
     */
    authorizeValidatorVote: {
      name: "AuthorizeValidatorVote",
      I: AuthorizeValidatorVoteRequest,
      O: AuthorizeValidatorVoteResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Requests the full viewing key from the custodian.
     *
     * Custody backends should decide whether to honor this request, and how to
     * control access to it.
     *
     * @generated from rpc penumbra.custody.v1.CustodyService.ExportFullViewingKey
     */
    exportFullViewingKey: {
      name: "ExportFullViewingKey",
      I: ExportFullViewingKeyRequest,
      O: ExportFullViewingKeyResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Displays an address to a user for confirmation.
     *
     * Custody backends with user interaction should present the address to the
     * user and wait for explicit confirmation before returning.
     *
     * Non-interactive custody backends may return immediately.
     *
     * @generated from rpc penumbra.custody.v1.CustodyService.ConfirmAddress
     */
    confirmAddress: {
      name: "ConfirmAddress",
      I: ConfirmAddressRequest,
      O: ConfirmAddressResponse,
      kind: MethodKind.Unary,
    },
  }
};

